import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  Checkbox,
  Grid,
  makeStyles,
  Menu,
  MenuItem,
  Typography,
  useTheme,
} from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import {
  addToMap,
  removeFromMap,
} from '../../../features/State Management/utilitiesSlice'
import { setTextArrayElement } from '../../../features/State Management/questionSlice'
import { getLocalizedValue } from '../../../utils/localeUtils'
import useLocale from '../../../customHooks/useLocale'

const useStyles = makeStyles((theme) => ({
  showsHidesButtons: {
    transform: 'scale(0.8)',
    // marginLeft: theme.spacing(1),
  },
}))

const EachOptionHides = ({ index }) => {
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  // Access store to get non-hidden questions
  // const shown = store.getState();
  const questions = useSelector((state) => state.questions)
  const qid = useSelector((state) => state.question.id)
  const option = useSelector((state) => state.question.options[index])
  const oid = option.id
  const shown = questions.filter(
    (q) =>
      (q.hidden === false || q.hidden === undefined) &&
      q.id !== qid &&
      q.type !== 'raw'
  )
  const hidesQuestions = useSelector(
    (state) => state.question.options[index].hides_questions
  )

  const dispatch = useDispatch()

  const [copy, setCopy] = useState(hidesQuestions ? hidesQuestions : [])

  useEffect(() => {
    dispatch(
      setTextArrayElement({
        property: 'options',
        index: index,
        value: { ...option, hides_questions: copy },
      })
    )
  }, [copy]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleMenuItemClick = (event, key) => {
    if (copy.indexOf(key) > -1) {
      // remove from totodispatch
      // remove from copy
      dispatch(
        removeFromMap({
          type: 'hidesMap',
          key: key,
          value: { qid: qid, oid: oid },
        })
      )
      setCopy(copy.filter((x) => x !== key))
    } else {
      // add to totodispatch
      // add to copy
      dispatch(
        addToMap({
          type: 'hidesMap',
          key: key,
          value: { qid: qid, oid: oid },
        })
      )
      setCopy([...copy, key])
    }
  }

  const classes = useStyles()

  const theme = useTheme()
  const locale = useLocale()
  return (
    <>
      <Button
        className={classes.showsHidesButtons}
        disableElevation
        size='small'
        // variant="contained"
        variant='outlined'
        onClick={handleClick}
      >
        hide
      </Button>
      <Menu
        id='simple-menu'
        anchorEl={anchorEl}
        // elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {shown && shown.length > 0 ? (
          shown.map((item) => {
            let itemTitle = item.title
            if (typeof itemTitle === 'object') {
              itemTitle = JSON.stringify(itemTitle)
            }
            const title =
              itemTitle !== undefined
                ? itemTitle.length > 30
                  ? `${itemTitle.slice(0, 29)}...`
                  : itemTitle
                : 'untitled'
            const menuItemStyle = {
              paddingLeft: theme.spacing(1),
              paddingRight: theme.spacing(3),
            }
            return (
              <MenuItem
                key={item.id}
                disableGutters
                style={menuItemStyle}
                button={true}
                onClick={(e) => handleMenuItemClick(e, item.id)}
              >
                <Grid
                  container
                  direction='row'
                  justifyContent='flex-start'
                  alignItems='center'
                  spacing={1}
                >
                  <Grid item>
                    <Checkbox
                      size='small'
                      color='primary'
                      checked={copy.indexOf(item.id) > -1}
                    />
                  </Grid>
                  <Grid item>
                    <Box fontWeight='fontWeightBold'>
                      <Typography color='primary'>{`v${index + 1}`}</Typography>
                    </Box>
                    {getLocalizedValue(title, locale)}
                  </Grid>
                </Grid>
              </MenuItem>
            )
          })
        ) : (
          <div>
            <NoneMenuItem />
          </div>
        )}
      </Menu>
    </>
  )
}

export default EachOptionHides

export const NoneMenuItem = () => {
  return (
    <MenuItem button={false}>
      <Box fontStyle='italic'>
        <Typography variant='body1'>None</Typography>
      </Box>
    </MenuItem>
  )
}
